import React, { Component } from 'react';
import { Ref } from "./App.js";
import SDate from "./sdate.js";

window.SDate = SDate;

export class Activity extends Component {
  tableSearch = [];
  orderWay = false;
  orderKey = "id"
  searchText = ""
  min = 0;
  maxRec = 10;
  pagesCount = 1;
  page = 1;
  activeOnly = true
  filters = {}

  state = { 
    tableView: [], 
    page: 1,
    cols: [],
    rows: [],
    tabLoading: false,
  }

  async componentDidMount() {//5min aktualizace
    //window.it = this;
    Ref.timers.actTimer = setInterval(() => this.update(), 5*60*1000);
    this.uStates = ((await window.fetchj("/aktivity_stav"))||{}).data || [];
  }

  async update() {
    const settings = {
      fulltextSearch: this.state.searchText,
      iRowsPerPage: this.maxRec,
      orderBy: this.orderKey + ":" + (this.orderWay ? "ASC" : "DESC"),
      iPageNo: this.page,
      colFilters: this.filters
    }

    if(this.activeOnly > 0) {
      settings.activeOnly = this.activeOnly === 1;
    }

    const tab = await window.fetchj("/aktivity", settings) || {}
    const rowInfo = (tab.data||[])[0] || {};

    this.pagesCount = rowInfo.pgCnt || 1;
    this.records = rowInfo.totCnt;
    this.min = this.page * this.maxRec - this.maxRec;

    if(tab.error) {
      console.error("Chyba ze serveru", tab);
      return Ref.InfoDialog.current.show("Chyba: " + tab.errorMsg);
    }

    this.setState({
      cols: tab.fields || [],
      rows: tab.data || [],
      tabLoading: false
    })
  }

  openDialog = async (row, fields) => {
    let r = await Ref.Dialog.current.show(row, fields);
    this.setState({tabLoading: true});
    if(r) await this.update();
    this.setState({tabLoading: false});
  }

  setFilter = max => {
    this.maxRec = max;
    this.min = 0;
    this.page = 1;
    this.setState({ tabLoading: true});
    return this.update();
  }

  sort = key => {
    this.orderWay = key === this.orderKey ? !this.orderWay : false;
    this.orderKey = key;
    this.update();
  }

  setPage = (page, plus = 0) => {
    page += plus;

    if(page < 1 || page > this.pagesCount || page == "...") return;
    this.page = page;
    this.setState({ tabLoading: true});
    return this.update();
  }

  search =async e=> {
    this.setState({ searchText: e.target ? e.target.value : e })
    if(this.timerHandle) clearTimeout(this.timerHandle);
    
    this.timerHandle = setTimeout(() => {
      this.setState({ tabLoading: true});
      this.page = 1;
      this.update();
    }, 800);
  }

  searchClear =async e=> {
    this.state.searchText = "";
    return this.update();
  }

  setActive =active=> {
    this.records = 0;
    this.setState({ tabLoading: true});

    this.min = 0;
    this.page = 1;
    this.activeOnly = active;
    this.update();
  }

  getPages = () => {
    let r = [];
    let page = this.page;

    let lastPage = this.pagesCount;//Math.ceil(this.records / this.max);
    let pageMin = page-2 > 0 ? page-2 : 1;
    let pageMax = page+2 < lastPage ? page+2 : lastPage;

    const li = (i, active) => 
      <li className={"paginate_button" + (active ? " active" : "")} onClick={() => this.setPage(i)}><a>{i}</a></li>

    if(page > 3 && lastPage > 3) {
      r.push(li(1))
      r.push(li("..."))
    }

    for(let i=pageMin;i<=pageMax;i++) {
      r.push(li(i, page == i))
    }

    if(page+2 < lastPage) {
      r.push(li("..."))
      r.push(li(lastPage))
    }

    return r;
  }

  getTD(fields, row) {
    return fields.filter(f=> f.visible).map((fd,i) => {
      const override = (row.fields_override || []).find(f => f.field == fd.field) || {};
      const field = { ...fd, ...override};
      let txt = row[field.field];

      if(txt !== undefined || txt !== null) {
        field.type === "d" && (txt = txt ? SDate(txt).fDate : "-");
        field.type === "b" && (txt = txt ? "Ano" : "Ne");

        if(field.type === "e" && field.enum && txt !== "") {
          const enm = field.enum.find(f => f.key == txt);
          txt = (enm || {}).disp;
        }
        
      }

      return (<td className={"field " + field.type + " " + field.field} key={i}>{String(txt || "-")}</td>);
    })
  }

  getRows(fields, data) {
    //<div className="btn btn-danger dropdown-toggle btn-sm itemList" onClick={() => this.remove(i)} ><i className="fa fa-trash-o"></i></div>
    
    return data.map((tr,i) => (
      <tr key={i}>
        { this.getTD(fields, tr) }
        <td className="actions">
          <div className="btn btn-warning btn-sm" onClick={() => this.openDialog(tr, fields)}><i className="fa fa-edit"></i></div>
        </td>
      </tr>
    ))
  }

  getFilters(fields) {
    const napoveda = "Hledat text ve sloupci - je možné používat tyto znaky: _ nebo % - libovolný znak nebo libovolný řetězec znaků, i prázdný";

    const inputs = fields.filter(f => f.visible).map((f,i) => {
      let input = 
        <input onChange={e=> this.filterChange(f.field, e.target.value, f.type)} title={napoveda} type="text" placeholder={"\uf002"} />

      if(f.type === "e" && f.enum) {
        input = <select onChange={e=> this.filterChange(f.field, e.target.value, f.type)}>
          <option value="">---</option>{(f.enum||[])
          .map(m => <option key={m.key} value={m.disp}>{m.disp}</option>)}</select>
      }

      if(f.field === "stav") {
        input = <select onChange={e=> this.filterChange(f.field, e.target.value, f.type)}>
          <option value="">---</option>{this.uStates.map((m,i) => <option key={i} value={m.stavPopis}>{m.stavPopis}</option>)}</select>
      }

      return (
        <td className="actions">{input}</td>
      )
    })

    return <tr className="filters">{inputs}<td></td></tr>
  }

  filterChange(field, value, type) {
    switch(type) {
      //datum se hleda jako text
      //case "d": value = value ? SDate(value).dmy : ""; break;
      case "f": value = +value.replace(",", "."); break;
    }
    
    this.filters[field] = value;
    if(value === "")      delete this.filters[field]

    if(this.timerHandle)  clearTimeout(this.timerHandle);
    
    this.timerHandle = setTimeout(() => {
      this.setState({ tabLoading: true });
      this.page = 1;
      this.update();
    }, 800);
  }


  render() {
    let {cols, rows} = this.state;
    if(!cols || !rows) return [];

    let recordsFrom = this.min + 1;
    let recordsTo = this.min + this.state.rows.length;

    if(recordsTo < recordsFrom) recordsFrom = recordsTo;

    return (
      <div className="main-content">
        <div className="panel-heading">Požadavky
          <div className="panel-tools bigger">
            <div className="btn btn-sm btn-success new-item" onClick={e => this.openDialog({id: null}, cols) }><i className="fa fa-plus"></i> Nový</div>
          </div>
        </div>
        <div className="panel-body">
          <div className="table-content">
            <div className="dataTables_wrapper dt-bootstrap no-footer">
              <div className="dataTables_length col-sm-6">
                <label>Zobrazit <select className="form-control input-sm m-wrap small" value={this.maxRec} onInput={e => this.setFilter(e.target.value)}>
                    <option value="2">2</option>
                    <option value="5">5</option>
                    <option value="10">10</option>
                    <option value="25">25</option>
                    <option value="50">50</option>
                    <option value="100">100</option>
                  </select> záznamů</label>
              </div>
              <div className="dataTables_filter">
                <label>
                  <input type="search" className="form-control input-sm" placeholder="Hledat" value={this.state.searchText} onInput={this.search} />
                    <button type="button" className="btn btn-orange btn-sm searchclrbtn" onClick={this.searchClear}><i className="fa fa-times"></i></button>
                </label>
              </div>
              <table id="tabAktivity" className={(this.state.tabLoading ? "tabLoading" : "") + " table table-striped display responsive table-bordered table-hover dataTable no-footer dtr-inline"}>
                <thead>
                  <tr role="row">
                    {cols.filter(f=> f.visible).map(f => 
                      <th className={"sorting a " + f.field + (this.orderKey == f.field ? " sort " + this.orderWay : "")} 
                        onClick={e=> this.sort(f.field)}>{f.caption}</th>
                    )}
                    <th>Akce</th>
                  </tr>
                </thead>
                <tbody>
                  {this.getFilters(cols)}
                  {this.getRows(cols, rows)}
                </tbody>
              </table>
              <div className="dataTables_info">
                Zobrazeno {recordsFrom} do {recordsTo} z {this.records || "0"} záznamů
              </div>
              <div className="dataTables_paginate paging_simple_numbers">
                <ul className="pagination">
                  <li className="paginate_button prev" onClick={() => this.setPage(this.page, -1)}><a>Předchozí</a></li>
                    {this.getPages(this.page, Math.ceil(this.maxRecords / this.maxRec))}  
                  <li className="paginate_button next" onClick={() => this.setPage(this.page, 1)}><a>Další</a></li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }
}